module.exports = __webpack_public_path__ + "img/scalepilot.923f46db.jpg";